import { useT } from '../context/LanguageContext';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, MapPin, Volleyball, Waves, Mountain, Gamepad2, Target, Dices, Dribbble } from 'lucide-react';
import { mockData } from '../mock';
import { useContent } from '../context/ContentContext';
import { EditButton } from './admin/EditorShell';
import { SchemaEditor } from './admin/SchemaEditor';
import { pictureUrl } from '../lib/api';

export const ACTIVITY_SCHEMA = [
  { key: 'title', label: 'Namn på aktiviteten' },
  { key: 'short', label: 'Kort tekst på framsida' },
  { key: 'slug', label: 'Ankernamn (små bokstavar, utan mellomrom)' },
  { key: 'image', label: 'Bilete', type: 'image' },
  { key: 'description', label: 'Skildring', type: 'textarea', rows: 3 },
];
export const useActivities = () => { const { content } = useContent(); return (content.activities || mockData.activities).map((a) => ({ ...a, image: a.image ? pictureUrl(a.image) : a.image })); };

export const activityIcon = (slug, size = 22) => {
  const map = { fotball: Dribbble, paintball: Target, volleyball: Volleyball, krik: Volleyball, president: Dices, bading: Waves, buldring: Mountain, gaming: Gamepad2 };
  const Cmp = map[slug] || MapPin;
  return <Cmp size={size} strokeWidth={2} />;
};

const Activities = () => {
  const { t } = useT();
  const activities = useActivities();
  const [editing, setEditing] = useState(false);
  return (
    <section id="aktiviteter" className="bg-black py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <h2 className="text-5xl md:text-7xl font-bold text-white tracking-tighter mb-4" style={{ fontFamily: "'Oktah Round', sans-serif" }}>
          {t('Aktivitetar')}
        </h2>
        <div className="flex items-start justify-between gap-4 mb-12"><p className="text-white/60 text-lg max-w-2xl">{t('Mykje gøy ventar deg denne helga. Trykk på ein aktivitet for å lese meir.')}</p><EditButton onClick={() => setEditing(true)} testId="edit-activities-button" /></div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {activities.map((a) => (
            <Link
              key={a.slug}
              to={`/aktiviteter#${a.slug}`}
              data-testid={`activity-card-${a.slug}`}
              className="group relative rounded-2xl bg-[#1a1424] border border-white/5 p-6 hover:border-[#ff2e2e] transition-colors"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-10 h-10 rounded-full bg-[#ff2e2e]/10 flex items-center justify-center text-[#ff2e2e]">
                  {activityIcon(a.slug)}
                </div>
                <ArrowUpRight size={20} className="text-white/40 group-hover:text-[#ff2e2e] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition" />
              </div>
              <h3 className="text-white font-semibold text-lg group-hover:text-[#ff2e2e] transition-colors">{t(a.short)}</h3>
            </Link>
          ))}
        </div>

        <div className="flex justify-center mt-10">
          <Link to="/aktiviteter" data-testid="activities-more-link" className="inline-flex items-center gap-2 text-[#ff2e2e] font-semibold hover:underline underline-offset-4">
            {t('Sjå meir om aktivitetane')} <ArrowUpRight size={18} />
          </Link>
        </div>
      </div>
      {editing && <SchemaEditor contentKey="activities" title="Rediger aktivitetar" initial={activities.map((a) => ({ id: a.slug, ...a }))} schema={ACTIVITY_SCHEMA} itemLabel="aktivitet" onClose={() => setEditing(false)} />}
    </section>
  );
};

export default Activities;
